"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPasskey = void 0;
const react_native_1 = require("@aws-amplify/react-native");
const errors_1 = require("./errors");
const getPasskey = async (input) => {
    try {
        return await (0, react_native_1.loadAmplifyRtnPasskeys)().getPasskey(input);
    }
    catch (err) {
        throw (0, errors_1.handlePasskeyAuthenticationError)(err);
    }
};
exports.getPasskey = getPasskey;
